var translations = {
    de: {
        headerTitle: 'Wir verhelfen Ihnen zur Traumimmobilie oder Ihrem Bauprojekt.',
        headerSubTitle: 'Bau-/Immobilienfinanzierung kostenlos & unverbindlich',
        selectLabel: 'Nettokreditbetrag',
        submitButtonTitle: 'Jetzt Kreditvergleich starten',
    },
};
export default translations;
